<template>
  <van-popup
    v-model="show"
    closeable
    round
    position="bottom"
    :style="{ height: '300px' }"
  >
    <div class="box-main">
      <div class="box-top">备注</div>
      <div class="flex box-type">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          @click="select(item)"
          :class="item.isSelect ? 'selected' : ''"
        >
          {{ item.type }}
        </div>
        <div class="otherBox">
          <textarea
            v-model="remark"
            cols="30"
            rows="6"
            maxlength="50"
            placeholder="请输入留言备注"
            class="otherType"
          ></textarea>
          <span class="valueLength">{{ remark.length + '/50' }}</span>
        </div>
      </div>
    </div>
    <div class="footer flex" @click="handleComfirm">
      <div class="placeOrder flex">确定</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      typeList: [
        { type: '缺包装袋', isSelect: false },
        { type: '缺文件袋', isSelect: false },
        { type: '退换货', isSelect: false },
        { type: '须本人签收', isSelect: false },
        { type: '易碎品', isSelect: false },
        { type: '重要文件', isSelect: false }
      ],
      remark: ''
    }
  },
  methods: {
    handleShow() {
      this.show = true
      if (this.$store.state.remark) {
        let obj = this.$store.state.remark
        for (let i of this.typeList) {
          for (let j of obj.type) {
            if (j === i.type) {
              i.isSelect = true
            }
          }
        }
        this.remark = obj.remark
      }
    },
    select(item) {
      item.isSelect = !item.isSelect
    },
    handleComfirm() {
      let regRule = new RegExp(
        "[`\\\\~!@#$^&*()+\\-=|{}':;\"',\\[\\]/\\s/.<>/?~！@%_#￥……&*·（）——|{}【】‘；：”“'。，、？]"
      )
      if (regRule.test(this.remark)) {
        this.$toast.fail('请勿输入特殊字符')
        return
      }
      const array = []
      const obj = {}
      for (const i in this.typeList) {
        if (this.typeList[i].isSelect) {
          array.push(this.typeList[i].type)
        }
      }
      obj.type = array.slice(0)
      obj.remark = this.remark
      this.$emit('getRemark', obj)
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.box-main {
  padding: 15px;
  .box-type {
    width: 100%;
    margin-top: 15px;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 14px;
    div {
      display: flex;
      justify-content: center;
      width: 25%;
      border: 1px solid #ccc;
      border-radius: 3px;
      margin-bottom: 0.5em;
      padding: 0.4em;
    }
    .selected {
      border-color: #e4b3b9;
      background-color: #f2dcdf;
      color: #a30014;
    }
    .otherBox {
      position: relative;
      border: none;
      padding: 0;
      width: 100%;
      .valueLength {
        position: absolute;
        bottom: 0.4em;
        right: 0.5em;
      }
    }
    .otherType {
      flex: 1;
      border: 1px solid #e4b3b9;
      border-radius: 3px;
      padding: 0.4em;
      resize: none;
    }
  }
  .box-item {
    display: flex;
    padding: 10px 0;
    font-size: 15px;
    .item-right {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }
  }
}
</style>
